
export default [

  {
    path: '/corp/register',
    name: 'corp-register',
    meta: {
      title: '企业注册'
    },
    component: resolve => require(['@/components/sys/corp/register/index.vue'], resolve)
  }
]



// WEBPACK FOOTER //
// ./src/router/corp/index.js